import { Headphones, Home } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TRUE } from "sass";

export const MENUITEMS = [
  {
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      // {
      //   title: "GG1 Tracking",
      //   icon: "gears",
      //   type: "link",
      //   active: false,
      //   path: `gg1-tracking`,
      // },
      {
        title: "Dashboards",
        icon: "gauge",
        type: "link",
        path: `dashboard/default`,
        active: false,
      },
      {
        title: "HR Services",
        icon: "gauge",
        type: "sub",

        active: true,

        children: [
          {
            title: "Employee Verification",
            icon: "gears",
            type: "link",
            active: true,
            path: `employ-verification`,
          },
          {
            title: "Employee Profile",
            icon: "gears",
            type: "link",
            active: true,
            path: `master-detail`,
          },
          {
            title: "Leave Application",
            icon: "gears",
            type: "link",
            active: true,
            path: `leaveapplication`,
          },
          // {
          //   title: "Verification Employeement",
          //   icon: "gears",
          //   type: "link",
          //   active: true,
          //   path: `dashboard/default`,

          // },
          // {
          //   title: "Employee Digital Signature",
          //   icon: "gears",
          //   type: "link",
          //   active: true,
          //   path: `dashboard/default`,
          // },
          {
            title: "Signature Management",
            icon: "gears",
            type: "link",
            active: true,
            path: `signature-management`,
          },
          {
            title: "Performance Evaluation",
            icon: "chart-simple",
            type: "link",
            active: true,
            path: `performance-evaluation`,
          },
          // {
          //   title: "Leave Share",
          //   icon: "page",
          //   type: "link",
          //   active: true,
          //   path: `share`,
          // },
          {
            title: "Leave Share Management",
            icon: "page",
            type: "link",
            active: true,
            path: `leave-share-management`,
          },
          {
            title: "Outside Employment",
            icon: "laptop",
            type: "link",
            active: true,
            path: `outside-employment`,
          },
        ],
      },
      {
        title: "Payroll Services",
        icon: "gauge",
        type: "sub",

        active: true,

        children: [
          {
            title: "Earning Statement",
            icon: "money",
            type: "link",
            active: true,
            path: `Employee-Earnings`,
          },
          {
            title: "Payroll Profile",
            icon: "chart-simple",
            type: "link",
            active: true,
            path: `payroll-profile`,
          },

          // {
          //   title: "Deduction Management ",
          //   icon: "gears",
          //   type: "link",
          //   active: true,
          //   path: `dashboard/default`,
          // },
          {
            title: "Employee Timesheet",
            icon: "chart-simple",
            type: "link",
            active: true,
            path: `timesheet`,
          },
          {
            title: "Employee Deduction",
            icon: "chart-simple",
            type: "link",
            active: true,
            path: `employeedeductionmaster`,
          },
        ],
      },
      // {
      //   title: "Activity",
      //   icon: "gauge",
      //   type: "link",
      //   path: `activities`,
      //   active: false,
      // },

      // {
      //   title: "Payroll Profile",
      //   icon: "chart-simple",
      //   type: "link",
      //   path: `payroll-profile`,
      //   active: false,
      // },
      // {
      //   title: "Performance Evaluation",
      //   icon: "chart-simple",
      //   type: "link",
      //   path: `performance-evaluation`,
      //   active: false,
      // },
      // {
      //   path: `leaveapplication`,
      //   icon: "page",
      //   title: "Leave Application",
      //   type: "link",
      // },

      // {
      //   // path: `outside-employment-record`,
      //   path: `outside-employment`,
      //   icon: "laptop",
      //   title: "Outside Employment",
      //   type: "link",
      //   //
      // },

      // {
      //   path: `employeeEarning`,
      //   icon: "money-bill",
      //   title: "Employee Earnings",
      //   type: "link",
      //   //
      // },
    ],
  },
];
